/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_reviews_filter = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		$(document).on('click', '.js-toggle-filters', function (e) {

			/**
			 * Show or hide .js-filter-selector-content
			 */
			$('.js-filter-selector-content').slideToggle(300);

		});

		/**
		 * Selector change, then go to new URL
		 */
		$(document).on('change', '.js-filter-selector', function (e) {

			/**
			 * Get: Values
			 */
			var _filter_problem = $('.js-filter-selector[data-filter="problem"]').val();
			var _filter_trainer = $('.js-filter-selector[data-filter="trainer"]').val();
			var _filter_breed = $('.js-filter-selector[data-filter="breed"]').val();

			/**
			 * Build URL
			 */
			var _new_url = 'reviews/filter?';

			if (_filter_problem != 'alle') {
				_new_url += 'probleem=' + _filter_problem + '&';
			}
			if (_filter_trainer != 'alle') {
				_new_url += 'trainer=' + _filter_trainer + '&';
			}
			if (_filter_breed != 'alle') {
				_new_url += 'hondenras=' + _filter_breed + '&';
			}

			/**
			 * Window location
			 */
			window.location.href = globalUrl + '/' + _language + '/' + _new_url;

		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_reviews_filter);